import { Box, Flex, Heading } from '@chakra-ui/react'
import React from 'react'
import {BrandLogo} from "../../../assets";
import { BRAND_NAME } from "../../../config/branding";

const Layout = ({ title, children }) => {
  return (
      <Box
          w="100%"
          minH="100vh"
          h="100vh"
          display="flex"
          justifyContent="center"
          alignItems="center"
          overflowY="auto"
      >
          <Flex
              w={{ base: '100%', md: 'md' }}
              maxH="90vh"
              overflowY="auto"
              align="center"
              direction="column"
              borderWidth="1px"
              borderRadius="lg"
              css={{ gap: '1.5rem' }}
              p={{ base: '4', md: '8' }}
          >
              <Box w="50%">
                  <img width="220" src={BrandLogo} alt={`${BRAND_NAME} Logo`}/>
              </Box>

              <Heading as="h6" size="md">
                  {title}
              </Heading>
              <Box w="100%">{children}</Box>
          </Flex>
      </Box>
  )
}

export default Layout
